/**
 * AccountDisabledScreen - Message for disabled creator accounts
 */

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertOctagon, Mail } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export function AccountDisabledScreen() {
  // FIX-R33-LOW-3: route signOut through AuthContext for consistent
  // localStorage cleanup.
  const { signOut } = useAuth();
  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/creator/auth';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertOctagon className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle>Account Disabled</CardTitle>
          <CardDescription>
            Your creator account has been disabled.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground text-center">
            If you believe this is an error or would like to request reactivation, 
            please contact the OptiBay team.
          </p>
          <div className="flex flex-col gap-2">
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => window.location.href = 'mailto:support@optibay.ai?subject=Creator%20Account%20Disabled'}
            >
              <Mail className="h-4 w-4 mr-2" />
              Contact Support
            </Button>
            <Button 
              variant="ghost" 
              className="w-full"
              onClick={handleSignOut}
            >
              Sign Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
